import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider, keepPreviousData } from '@tanstack/react-query';
import { App } from './App';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The dashboard polls; a failed poll shouldn't stack retries on top of it.
      retry: 1,
      refetchOnWindowFocus: true,
      // Serve cached data as fresh for 30s so switching tabs doesn't blank the screen on
      // every focus, and keep the previous tab's rows/counts on screen while the next load
      // is in flight rather than flashing empty.
      staleTime: 30_000,
      placeholderData: keepPreviousData,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
